/**
 * Lib.Common: Navigation component declarations
 */


import ibSnackbar           from './ib-snackbar.vue';


export default [
    ibSnackbar
];
